import React from "react"
import CollectionPage from "../technologies-services/TechnologiesServicesPage"

export default () => <CollectionPage slug="sustainability" />
